import React, { Dispatch, SetStateAction, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useApi } from "../../../../../../hooks/useApi";
import Loader from "../../../../../DefaultStyles/Loader";
import AlertModal from "../../../../../Modal/AlertModal";

interface NotiRegistAlertModalProps {
  setRegisterAlertModal: Dispatch<SetStateAction<boolean>>;
  closeEvent: () => void;
  confirmEvent?: () => void;
  inputData: {
    uid: number;
    type: number;
    messageid: number;
    id: number;
  };
  modalType?: string;
}

export default function NotiRegistAlertModal({
  closeEvent,
  setRegisterAlertModal,
  confirmEvent,
  inputData,
  modalType,
}: NotiRegistAlertModalProps) {
  const [registerPopup, setRegisterPopup] = useState(false);
  const [editPopup, setEditPopup] = useState(false);

  const modalResString = modalType === "edit" ? "수정" : "등록";

  // 팝업 추가
  const { response, error, loading } = useApi({
    method: "post",
    url: registerPopup ? `popup` : undefined,
    data: {
      uid: inputData?.uid ?? 0,
      type: inputData?.type ?? 0,
      messagid: inputData?.messageid ?? 0,
      showDate: "",
    },
  });

  // 팝업 수정
  const {
    response: editRes,
    error: editError,
    loading: editLoading,
  } = useApi({
    method: "post",
    url: editPopup ? `popup/${inputData?.id}` : undefined,
    data: {
      uid: inputData?.uid ?? 0,
      type: inputData?.type ?? 0,
      messagid: inputData?.messageid ?? 0,
      showDate: "",
    },
  });

  useEffect(() => {
    if (
      response?.status === 200 ||
      editRes?.status === 200 ||
      editRes?.status === 201
    ) {
      closeEvent();

      if (confirmEvent) confirmEvent();
      toast.success(`팝업 ${modalResString}이 완료되었습니다.`);
    }
  }, [response, editRes]);

  useEffect(() => {
    if (error || editError) {
      toast.error(
        editError?.data ??
          error?.data ??
          `팝업 ${modalResString}에 실패하였습니다.`
      );
      setRegisterPopup(false);
      setEditPopup(false);
    }
  }, [error, editError]);

  return (
    <>
      <AlertModal
        title={`팝업을 ${modalResString}하시겠습니까?`}
        cancelEvent={() => setRegisterAlertModal(false)}
        confirmEvent={() => {
          if (modalType === "edit") {
            setEditPopup(true);
          } else {
            setRegisterPopup(true);
          }
        }}
        btnColor="mint"
      />

      {(loading || editLoading) && <Loader />}
    </>
  );
}
